module.exports = __webpack_public_path__ + "media/images/icon__point--lost@3x-4f80dc41e22b425a37bbaacc23646594.png";